import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core'
import { AmChartsService } from '@amcharts/amcharts3-angular'
import { FormControl, FormGroup } from '@angular/forms'
import { CpmService } from 'app/service/cpm.service'
import { PdfChart } from 'app/shared/pdfChart'
import { ActivatedRoute } from '@angular/router'
import { ExportPPTService } from 'app/service/export-ppt.service'

@Component({
  selector: 'app-historical-indices',
  templateUrl: './historical-indices.component.html',
  styleUrls: ['./historical-indices.component.scss']
})
export class HistoricalIndicesComponent implements OnInit, OnDestroy, AfterViewInit {
  radioMarketP
  getPrint
  marketValue = ''
  dataChart
  indicesData
  chartHistorical
  year
  tradingDate
  displayType
  form: FormGroup
  indices
  pdfChart: PdfChart = new PdfChart()
  constructor(
    private amCharts: AmChartsService,
    private activatedRoute: ActivatedRoute,
    private cpmService: CpmService,
    private pptService: ExportPPTService
  ) { }

  ngOnInit() {
    const { marketValue } = this.activatedRoute.snapshot.params
    const { pdf } = this.activatedRoute.snapshot.data
    const { print } = this.activatedRoute.snapshot.data

    this.getPrint = print;

    this.pdfChart.setPdf(pdf)
    marketValue === undefined
      ? (this.marketValue = '')
      : (this.marketValue = marketValue.toLowerCase())

    this.radioMarketP = [
      { value: '', des: 'Total (SET and mai)' },
      { value: 'set', des: 'SET' },
      { value: 'mai', des: 'mai' }
    ]

    this.form = new FormGroup({
      marketValue: new FormControl(this.marketValue)
    })

    this.getLastTradingDate().then(endYear => {
      this.year = endYear
      this.markData(this.form.get('marketValue').value)
    })
  }

  ngOnDestroy() {
    if (
      this.chartHistorical &&
      this.chartHistorical.legend &&
      this.chartHistorical.legend.destroy
    ) {
      const tmp =
        this.chartHistorical != null
          ? this.amCharts.destroyChart(this.chartHistorical)
          : null
    }
  }

  async getLastTradingDate(): Promise<number> {
    const date = await this.cpmService.getLastTradingDate()
    const lastTrading = new Date(date.lastTradingDate.toString())
    const options = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }
    let dateTime
    dateTime = lastTrading.toLocaleDateString('en-EN', options)
    this.tradingDate = dateTime
    return lastTrading.getFullYear()
  }

  onChangeData() {
    this.dataChart = []
    if (this.chartHistorical != null) {
      this.amCharts.destroyChart(this.chartHistorical)
    }
    this.marketValue = this.form.get('marketValue').value
    this.markData(this.form.get('marketValue').value)
  }

  async markData(indexName) {
    let displayIndex = []
    if (indexName === '') {
      displayIndex = ['set', 'mai']
    } else {
      displayIndex = [indexName]
    }
    const allIndex = await Promise.all(
      displayIndex.map(index => {
        return this.cpmService.getMarketStatisticByYear(index, 1975, this.year)
      })
    ).then(result => {
      return result
        .reduce((acc, val) => acc.concat(val), [])
        .reduce((obj, item) => {
          if (!obj[item['year']]) {
            obj[item['year']] = {}
            obj[item['year']]['year'] = item['year']
            obj[item['year']]['indices'] = []
          }
          obj[item['year']][item['indexName'].toLowerCase() + 'Index'] =
            item['indexClose']
          obj[item['year']][item['indexName'].toLowerCase() + 'MarketCap'] =
            item['marketCap'] / 1000000
          obj[item['year']]['indices'].push({
            indexName: item.indexName,
            indexClose: item.indexClose,
            marketCap: item.marketCap / 1000000
          })
          return obj
        }, {})
    })

    const years = Object.keys(allIndex).map(year => allIndex[year].year)
    const maxYear = Math.max(...years)
    this.indicesData = Object.keys(allIndex).map(year => allIndex[year])

    this.indices = allIndex[maxYear + ''].indices
    // *** Edit
    if (indexName === '') {
      this.indices.push({
        indexName: 'Total',
        marketCap: allIndex[maxYear + ''].indices.reduce((sum, item) => {
          return sum + item.marketCap
        }, 0)
      })
    }

    const graphs = []
    if (displayIndex.includes('set')) {
      graphs.push({
        id: 'g3',
        valueAxis: 'v2',
        bullet: 'round',
        bulletBorderAlpha: 1,
        bulletSize: 5,
        hideBulletsCount: 50,
        lineThickness: 2,
        lineColor: '#b35900',
        type: 'smoothedLine',
        title: 'SET index (Left)',
        useLineColorForBulletBorder: true,
        smoothedLine: true,
        valueField: 'setIndex',
        balloonText: '<b>SET index: [[value]]</b>'
      })
    }
    if (displayIndex.includes('mai')) {
      graphs.push({
        id: 'g4',
        valueAxis: 'v2',
        bullet: 'round',
        bulletBorderAlpha: 1,
        bulletSize: 5,
        hideBulletsCount: 50,
        lineThickness: 2,
        lineColor: '#20acd4',
        type: 'smoothedLine',
        title: 'mai index (Left)',
        useLineColorForBulletBorder: true,
        smoothedLine: true,
        valueField: 'maiIndex',
        balloonText: '<b>mai index: [[value]]</b>'
      })
    }
    if (displayIndex.includes('set')) {
      graphs.push({
        id: 'g1',
        valueAxis: 'v1',
        lineColor: '#FFBF00',
        fillColors: '#FFBF00',
        fillAlphas: 1,
        type: 'column',
        title: 'SET market cap (Right)',
        valueField: 'setMarketCap',
        clustered: false,
        columnWidth: 0.5,
        // balloonText: '<b>SET [[value]]M</b>',
        balloonFunction: function (graphDataItem, graph) {
          let value = graphDataItem.values.value;
          value = parseFloat(value).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          return 'SET: ' + value + ' M';
        }


      })
    }
    if (displayIndex.includes('mai')) {
      graphs.push({
        id: 'g2',
        valueAxis: 'v1',
        lineColor: '#848484',
        fillColors: '#848484',
        fillAlphas: 1,
        type: 'column',
        title: 'mai market cap (Right)',
        valueField: 'maiMarketCap',
        clustered: false,
        columnWidth: 0.5,
        // balloonText: '<b>mai [[value]]M</b>'
        balloonFunction: function (graphDataItem, graph) {
          let value = graphDataItem.values.value;
          value = parseFloat(value).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          return 'mai: ' + value + ' M';
        }
      })
    }
    this.displayType = displayIndex
    this.dataChart = {
      type: 'serial',
      theme: 'light',
      precision: 2,
      fontFamily: 'browallia',
      fontSize: 18,
      valueAxes: [
        {
          id: 'v1',
          stackType: 'regular', // add for stackType
          title: 'Market cap (M.Baht)',
          position: 'right',
          autoGridCount: false
        },
        {
          id: 'v2',
          title: 'Index (Point)',
          gridAlpha: 0,
          position: 'left',
          autoGridCount: false
        }
      ],

      dataProvider: this.indicesData,
      graphs: graphs,
      chartCursor: {
        pan: true,
        categoryBalloonEnabled: false,
        cursorAlpha: 0,
        valueLineAlpha: 0.2
      },
      categoryField: 'year',
      categoryAxis: {
        dashLength: 1,
        minorGridEnabled: true,
        gridAlpha: 0,
        minorGridAlpha: 0
      },
      legend: {
        useGraphSettings: true,
        position: 'bottom',
        align: 'center',
        valueText: ''
      },
      balloon: {
        borderThickness: 1,
        shadowAlpha: 0
      },
      titles: [
        {
          id: 'Title-1',
          text: 'Historical indices and market cap'
        }
      ]
    }

    // console.log("this.dataChart chartdiv--", this.dataChart);
    this.chartHistorical = this.amCharts.makeChart(
      'historicalIndicesChartdiv',
      this.dataChart
    )

    if (document.getElementById('historicalIndicesChartdiv')) {
      document
        .getElementById('historicalIndicesChartdiv')
        .classList.add('chartFinished')
    }
  }

  ngAfterViewInit() {
    if (this.getPrint) {
      window.setTimeout('window.print()', 2500);
    }
  }

  Ppt() {
    this.pptService.pptHistoricalIndices(this.indicesData, this.form.get('marketValue').value)
  }
  get getRemark() {
    return 'Remark: ตลาดหลักทรัพย์ เอ็ม เอ ไอ (mai) เริ่มมีหลักทรัพย์จดทะเบียนในปี 2001 แต่เริ่มคำนวณ mai index ในปี 2002';
 }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/market-level/historical-indices/historical-indices.component.ts